<div class="customer-dropdown-container">
  <label>Customer:</label>
  <div class="container">

    <div class="search-select-wrapper" [class.open]="showDropdown">
      <span class="search-icon">
        <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
          <circle cx="9" cy="9" r="6" stroke="#9CA3AF" stroke-width="2"/>
          <path d="M13.5 13.5L17 17" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </span>
      <input
        type="text"
        [(ngModel)]="searchText"
        (input)="onSearchInput()"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (keydown)="onKeydown($event)"
        placeholder="Search customer..."
        class="customer-search-input"
        autocomplete="off"
      />
      <span class="clear-icon" *ngIf="searchText" (mousedown)="clearSelection($event)">×</span>

      <div class="search-dropdown" *ngIf="showDropdown">
        <div *ngIf="filteredCustomers.length === 0" class="search-option no-results">
          No customers found
        </div>
        <div
          *ngFor="let customer of filteredCustomers; let i = index"
          class="search-option"
          [class.active]="i === activeIndex"
          (mousedown)="selectCustomer(customer)"
        >
          {{ getCustomerDisplayName(customer) }}
        </div>
      </div>
    </div>

    <button mat-raised-button class="register-button" (click)="navigateToRegister()">
      Register
    </button>
  </div>
</div>
